import React, { useState } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";


export default function IconNavigator({

    id,

    label,

    icon,

    clickFunction

})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hovered, setHovered] =
        useState(false);


    //--------------------------------------------------------
    // Container
    //--------------------------------------------------------

    const iconNavigatorContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        alignItems:
            "center",

        justifyContent:
            "flex-start",

        flex:
            1
    };


    //--------------------------------------------------------
    // Icon container
    //--------------------------------------------------------

    const iconContainer =
    {
        display:
            "flex",

        width:
            "50px",

        height:
            "50px",

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        //----------------------------------------------------
        // Graphite at rest / blue on interaction
        //----------------------------------------------------

        background:

            hovered

                ?

                `linear-gradient(
                    180deg,
                    #45afe0 0%,
                    #2695cc 100%
                )`

                :

                `linear-gradient(
                    145deg,
                    #30353a 0%,
                    #1b1f22 55%,
                    #0d0f11 100%
                )`,

        border:

            hovered

                ?

                "1px solid rgba(255,255,255,0.28)"

                :

                "1px solid rgba(255,255,255,0.12)",

        boxShadow:

            hovered

                ?

                `
                0 6px 16px rgba(38,149,204,0.30),
                inset 0 1px 0 rgba(255,255,255,0.24)
                `

                :

                `
                0 4px 10px rgba(0,0,0,0.28),
                inset 0 1px 0 rgba(255,255,255,0.08)
                `,

        cursor:
            "pointer",

        transform:

            hovered

                ? "translateY(-2px)"

                : "translateY(0)",

        transition:
            "background 0.18s ease, " +
            "border 0.18s ease, " +
            "box-shadow 0.18s ease, " +
            "transform 0.18s ease"
    };


    //--------------------------------------------------------
    // Icon
    //--------------------------------------------------------

    const iconStyle =
    {
        width:
            "20px",

        height:
            "20px",

        color:

            hovered

                ? "#ffffff"

                : "#8dc8f0",

        filter:

            hovered

                ? "drop-shadow(0 1px 2px rgba(0,0,0,0.16))"

                : "none",

        transition:
            "color 0.18s ease"
    };


    //--------------------------------------------------------
    // Label
    //--------------------------------------------------------

    const iconNavigatorText =
    {
        display:
            "flex",

        minHeight:
            "30px",

        paddingTop:
            "7px",

        alignItems:
            "flex-start",

        justifyContent:
            "center",

        color:

            hovered

                ? "#ffffff"

                : "rgba(255,255,255,0.72)",

        fontSize:
            "12px",

        fontWeight:

            hovered

                ? 600

                : 500,

        textAlign:
            "center",

        transition:
            "color 0.18s ease"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={iconNavigatorContainer}>

            <div

                style={iconContainer}

                onClick={clickFunction}

                onMouseEnter={

                    function()
                    {

                        setHovered(true);

                    }

                }

                onMouseLeave={

                    function()
                    {

                        setHovered(false);

                    }

                }

            >

                <FontAwesomeIcon

                    icon={icon}

                    style={iconStyle}

                />

            </div>


            <div style={iconNavigatorText}>

                {label}

            </div>

        </div>

    );

}